module.exports = __webpack_public_path__ + "img/quick-btn2.d708c91a.png";